import React from 'react';
import clsx from 'clsx';

export default function TextBoxInput({
    label,
    disabled,
    value,
    name,
    height,
    onChange,
    error,
}: {
    label?: React.ReactNode;
    disabled?: boolean;
    value: string | undefined | number | null;
    name?: string;
    height?: string;
    error?: string | undefined | boolean;
    onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}) {
    return (
        <label className="relative w-full font-normal mb-0 block">
            {label && (
                <div className="text-sm font-medium text-label mb-1.5 whitespace-nowrap">
                    {label}
                </div>
            )}
            <div
                className={clsx(
                    'relative border rounded-lg transition-colors',
                    height || 'h-32',
                    error
                        ? 'border-danger-border'
                        : 'border-border focus-within:border-border-strong',
                    disabled ? 'bg-border-subtle' : 'bg-surface-muted'
                )}
            >
                <textarea
                    className={clsx(
                        'w-full h-full resize-none focus:outline-none bg-transparent text-sm text-foreground placeholder-foreground-muted p-3',
                        disabled ? 'cursor-not-allowed' : ''
                    )}
                    name={name}
                    onChange={onChange}
                    value={value || ''}
                    maxLength={200}
                    disabled={disabled}
                />
            </div>
            {error && <p className="mt-1 text-xs text-danger">{error}</p>}
        </label>
    );
}
